var _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvitationCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.7704C2.5 10.027 3.28231 9.5435 3.94721 9.87595L11.5528 13.6787C11.8343 13.8195 12.1657 13.8195 12.4472 13.6787L20.0528 9.87595C20.7177 9.5435 21.5 10.027 21.5 10.7704V16.5523C21.5 18.7615 19.7091 20.5523 17.5 20.5523H6.5C4.29086 20.5523 2.5 18.7615 2.5 16.5523V10.7704Z",
    stroke: "#252529",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6496 11.0512V5.45117C18.6496 4.3466 17.7542 3.45117 16.6496 3.45117H7.34961C6.24504 3.45117 5.34961 4.3466 5.34961 5.45117V11.0512",
    stroke: "#252529",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.1504,
    y1: 8.15234,
    x2: 13.8504,
    y2: 8.15234,
    stroke: "#252529",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationCode);
export default __webpack_public_path__ + "static/media/Invitation-code.4bc8c09c56b2a52f1353545a196eada6.svg";
export { ForwardRef as ReactComponent };